<!-- todo -->
<template>
  <div>
    <!-- <div class="split-line"></div> -->
    <h3>用药建议</h3>
    <template v-for="medical in prescriptionDetail.medicationList">
      <el-row>
        <el-col :span="8">
          <label>药名：</label>
          <span>{{ medical.drugName }}</span>
        </el-col>
        <el-col :span="8">
          <label>规格：</label>
          <span>{{ medical.spec }}</span>
        </el-col>
        <el-col :span="8">
          <label>用法用量：</label>
          <span>{{ medical.use }}</span>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <label>数量：</label>
          <span>{{ medical.num }}</span>
        </el-col>
      </el-row>

      <el-row v-if="medical.remark">
        <el-col :span="24">
          <label>备注：</label>
          <span>{{ medical.remark }}</span>
        </el-col>
      </el-row>
      <el-row v-if="medical.warn">
        <el-col :span="24">
          <label>特别提醒：</label>
          <span class="strong-color">{{ medical.warn }}</span>
        </el-col>
      </el-row>
    </template>
    <el-row v-if="prescriptionDetail.supplementaryNotes">
      <el-col :span="24">
        <label>补充说明：</label>
        <span>{{ prescriptionDetail.supplementaryNotes }}</span>
      </el-col>
    </el-row>
    <el-row v-if="prescriptionDetail.doctorChangeExplain">
      <el-col :span="24">
        <label>修改说明：</label>
        <span class="strong-color">{{ prescriptionDetail.doctorChangeExplain }}</span>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'drugAdvice',
  props: {
    prescriptionDetail: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  methods: {}
};
</script>

<style lang="scss"></style>
